const PlaySound = (sound: string): HTMLAudioElement => {
    const domain = window.location.origin;
    sound = domain + sound;
    let audio = new Audio(sound);
    audio.play().catch((error) => console.warn("ERROR WITH PLAY SOUND: " + error) );
    
    return audio;
}
export default PlaySound;